'use client';
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type { StockMapProps } from '../createStockPage';
import { StockMapLoading } from '../stockMapLoading';

// Client-only + lazy (mapbox + recharts run browser-only). ssr:false must live
// in a client component; the cast restores the prop type next/dynamic widens.
const Ioniq5nInventoryMap = dynamic(
  () => import('./ioniq5nMap').then((m) => m.Ioniq5nInventoryMap),
  {
    ssr: false,
    loading: () => <StockMapLoading />,
  },
);

export default Ioniq5nInventoryMap as ComponentType<StockMapProps>;
